import { SvgIcon } from '@material-ui/core';
import moment from 'moment';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { globalColors } from '../../../../../../_metronic/_assets/sass/custom/globalColors';
import { ReactComponent as iconPlus } from '../../../../../assets/icons/icon-plus-green.svg';
import lawsuit from '../../../../../assets/icons/clientes.svg';
import { lawsuitStatus } from '../../../../../enum/LawsuitStatus';
import CrudActions from '../../../../../partials/datatable/CrudActions';
import Datatable from '../../../../../partials/datatable/Datatable';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../partials/datatable/styles';
import store from '../../../../../store/store';
import Loading from '../../../../home/components/Loading';
import { AppAPIService } from '../../../../../services/AppAPIService';
import { ClassesProcessuaisSelect } from './components/ClassesProcessuaisSelect';

const headRows = [
  { column: 'Opções', label: 'Ações', sortable: false },
  { column: 'text', label: 'Texto' },
  { column: 'value', label: 'Valor' },
  { column: 'updated_at', label: 'Data de modificação' },
];

const status = lawsuitStatus;

export const ClassesProcessuaisListing = (props) => {
  const { auth } = store.getState();
  const api = AppAPIService.getInstance();

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async (id) => {
    try {
      setLoading(true);
      await api.makeHttpRequest({
        method: 'DELETE',
        url: `/procedural-class/${id}`,
      });

      setReload(!reload);
      setLoading(false);
      Swal.fire({
        title: 'Sucesso!',
        text: 'Processo deletado com sucesso.',
        icon: 'success',
        cancelButtonText: 'Sair',
      });
    } catch (e) {
      Swal.fire('Erro!', 'Erro ao deletar processo.', 'error');
    }

    setLoading(false);
  };

  const formatRow = (r) => {
    let crudActions = ['delete'];
    return (
      <StyledTableRow key={r.id} hover tabIndex={-1}>
        <StyledTableCell scope="row" style={{ padding: '0px 10px', width: '48px' }}>
          <CrudActions
            actions={crudActions}
            module="classes-processuais"
            onConfirmChangeStatus={() => null}
            onConfirmDelete={handleConfirmDelete}
            id={r.id}
            obj={r}
            titleMessageDelete={''}
            addMessage={'Deseja deletar esse processo?'}
          />
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: '4px 0px', textAlign: 'left', paddingLeft: 10 }}
        >
          {r.text}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: '4px 0px', textAlign: 'left', paddingLeft: 10 }}
        >
          {r.value}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: '4px 0px', textAlign: 'left', paddingLeft: 30 }}
        >
          {r.updated_at ? moment(r.updated_at).format('DD/MM/YYYY') : '--/--/----'}
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Datatable
        title="Classes Processuais"
        icon={<img src={lawsuit} alt="Adicionar" />}
        endpoint="procedural-class"
        className="bg-white"
        headRows={headRows}
        formatRow={formatRow}
        rows={[]}
        reload={reload}
        placeholderSearch="Busque por texto ou valor"
        width={props.width}
        tooltip="Cadastrar nova pessoa"
        hiddenReload
        personInputs
        personStatusFilter={status}
        hiddenKanbanContent
        colorButton={globalColors.transparent}
        titleButon={
          <SvgIcon
            component={iconPlus}
            alt="Cadastrar novo processo"
            fill={globalColors.primaryColor1}
            viewBox="0 0 16 15"
            style={{
              width: '30px',
              height: '32px',
              fill: globalColors.primaryColor1,
              color: globalColors.primaryColor1,
              display: auth?.user?.role === 'ADMIN' ? 'block' : 'none',
            }}
          />
        }
        removeMinHeight
        removeTableShadow
        removePadding
        removeTitleMargin
        addSelect={
          <ClassesProcessuaisSelect
            setIsLoading={setLoading}
            setReload={setReload}
            reload={reload}
          />
        }
      />
    </>
  );
};
